import React, {Component} from 'react';
import { localize } from 'react-localize-redux';
import { GoogleMap, Marker, withGoogleMap, withScriptjs, InfoWindow } from 'react-google-maps';

import mapPin from 'Content/Assets/images/maps/map-marker_100.png';
import GoogleInfoBox from './GoogleInfoBox';
import * as mapsServices from 'services/maps/googleMapControlsServices';

class GoogleMapIcnSinglePin extends Component {

    constructor(props){
        super(props)

        this.onToggleOpenMainInfoWindow = this.onToggleOpenMainInfoWindow.bind(this);

        /*
            attenzione! per utilizzare le librerie native di google ho due strade
            1- aggiungere il link nella pagina index.html
            2- utilizzare HOC withScriptjs

            e per poterle utilizzare bisogna dichiarare
            const google = window.google;
        */

        var zoom = props.zoom;

        if(!zoom)
        {
            zoom = 12;
        }

        this.state = {
            isOpenMainInfoWindow: false,
            zoom
        };
    }

    componentDidMount(){

        /*
            aggiungo controlli custom: center page e speed legend
        */
       mapsServices.createCenterControl(this.props.translate, this.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, this.props.position);
    }

    /**
     * gestisce la chiusura o apertura dell'info windows del pin
    */
    onToggleOpenMainInfoWindow(){
        this.setState({
            isOpenMainInfoWindow: !this.state.isOpenMainInfoWindow
        });
    }

    render() {

        console.info("google map single ping rendered");

        var {translate, position, isMarkerShown, dateTime, addres, icnPlus, isMilesPerHour, speed, unitOfMeaserLabel,
            pdof, icnId } = this.props;

        var {isOpenMainInfoWindow, zoom} = this.state;

        return (
            <div>

            <GoogleMap
                ref={(ref) => { this.map = ref; }}
                defaultZoom={zoom}
                defaultOptions={
                    {
                        gestureHandling: 'greedy'
                    }
                }
                defaultCenter={ position }
                >
                {
                    isMarkerShown && position &&
                    <Marker
                        icon={mapPin}
                        position={ position}
                        onClick={this.onToggleOpenMainInfoWindow}
                        >
                        {isOpenMainInfoWindow &&
                                <InfoWindow onCloseClick={this.onToggleOpenMainInfoWindow} >
                                    <GoogleInfoBox translate={translate} dateTime={dateTime} position={position}
                                        icnPlus={icnPlus} addres={addres} isMilesPerHour={isMilesPerHour}
                                        preCrashSpeed={speed} unitOfMeaserLabel={unitOfMeaserLabel} pdof={pdof} icnId={icnId} />
                                </InfoWindow>
                        }
                    </Marker>
                }
            </GoogleMap>
            </div>
        );
    }
}

export default withScriptjs(withGoogleMap(localize(GoogleMapIcnSinglePin, 'locale')));


// WEBPACK FOOTER //
// ./src/components/maps/GoogleMapIcnSinglePin.js